import { prepareChessboard, restrictMove, validateMove, showMagnus, loadNextConfiguration, plotArrow } from '../../utils';
import ChessBoard from '../../components/chessBoard';
import $ from 'jquery';
import User from '../../classes/user';
import {
  WRONG_ANSWER_AUDIO
} from '../../utils/constants'

/**
* @name lesson12Assignment
* @function
* @param {config}
* @description: activity related task
*/
export function lesson12Assignment(config) {

  let moveSpeed = 1000,
    next = config.next,
    coordinates = config.prefilledCoordinates,
    computerTime = config.computerMoveIn,
    nextComputerMoveIn = computerTime ? computerTime : 2000,
    //nextStudentMoveIn = config.studentTime ? config.studentTime : 2000, 
    newFilledSquares = config.newFilledSquares ? true : false,
    magnusPopUp = config.magnusPopUp ? true : false,
    offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  }

  let afterLoad = function () {
    prepareChessboard(config);
    if (config.prefilledCoordinates) {
      setTimeout(function () {
        coordinates.forEach(element => {
          $(element).addClass('filled-yellow-square')
        });
      }, config.filledSquareTimeOut)
    }
    if (config.from && config.to) {
      setTimeout(function () {
        if (newFilledSquares) {
          coordinates.forEach(element => {
            $(element).removeClass('filled-yellow-square')
          });
        }
        ChessBoard.board.move(config.from + "-" + config.to);
      }, 1000);
      setTimeout(function () {
        if (newFilledSquares) {
          $('#myCanvas').addClass('show').removeClass('hide');
          var c = document.getElementById('myCanvas');
          var ctx = c.getContext('2d');
          ctx.clearRect(0, 0, c.width, c.height);
          plotArrow(ctx, config.fromCanvas, config.toCanvas, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, '#FFA500');
        }
      }, 3500);
      loadNextConfiguration(nextComputerMoveIn, next, false)
    }
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, config.restrictMoveOf)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target, piece, false)
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();
    if (boardFen === config.final) {
      if (magnusPopUp) {
        showMagnus({
          data: `${config.MagnusText} ${User.user.name}!`,
          position: 'left',
          styleClass: 'sm'
        })
      }
      loadNextConfiguration(2000, next, true)
    }
    else {
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
      if (source === 'h5' && target === 'h4') {
        showMagnus({
          data: config.otherRookMovementMessage,
          styleClass: 'md',
          position: 'left'
        })
      }
      else {
        showMagnus({
          data: config.wrongMessage,
          position: 'left',
          styleClass: 'sm'
        })
      }
      setTimeout(function () {
        showMagnus({
          data: 'Move the piece to the correct position.',
          position: 'left',
          styleClass: 'md'
        })
        ChessBoard.board.position(config.position);
        ChessBoard.game = new window.Chess(config.position + config.initialMove);
        return 'snapback';
      }, 3000)
    }
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_12/assignments.js